import { fetchBrand, fetchBrands } from '../queries/brands.queries'

import { skipToken, useQuery } from '@tanstack/react-query'

export const useBrands = () =>
  useQuery({
    queryKey: ['brands'],
    queryFn: fetchBrands,
  })

export const useBrand = (id?: number) =>
  useQuery({
    queryKey: ['brand', id],
    queryFn: id && id > 0 ? () => fetchBrand(id) : skipToken,
    staleTime: 24 * 60 * 60 * 1000, // 86400000 millisecondes (a day)
  })
